/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EntityActivityDto = {
    /**
     * Activity UUID
     */
    id: string;
    /**
     * Entity type for the activity
     */
    entityType: EntityActivityDto.entityType;
    /**
     * Entity UUID
     */
    entityId: string;
    /**
     * Activity action type
     */
    actionType: string;
    /**
     * Activity description
     */
    description?: string | null;
    /**
     * Additional metadata payload
     */
    metadata?: Record<string, any> | null;
    /**
     * Created timestamp
     */
    createdAt: string;
    /**
     * Created by user UUID
     */
    createdBy?: string | null;
};
export namespace EntityActivityDto {
    /**
     * Entity type for the activity
     */
    export enum entityType {
        QUOTE = 'QUOTE',
        POLICY = 'POLICY',
        CLIENT = 'CLIENT',
    }
}

